<template>
  <v-overlay
    :value="isTranslating"
    z-index="9999"
    opacity="0"
    class="d-flex align-center justify-center"
  >
    <div class="loader-wrapper">
      <div class="pulse-ring" :style="{ borderColor: color }"></div>
      <div class="pulse-ring delay" :style="{ borderColor: color }"></div>

      <div class="glass-circle">
        <v-icon :color="color" size="88"> mdi-translate </v-icon>
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "TranslateLanguageLoaderV2",
  props: {
    color: {
      type: String,
      default: "#ff1d5e",
    },
  },
  computed: {
    isTranslating() {
      return this.$root.isTranslating || false;
    },
  },
};
</script>

<style scoped>
.loader-wrapper {
  position: relative;
  width: 160px;
  height: 160px;
}

.glass-circle {
  position: relative;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.26);
  backdrop-filter: blur(22px);
  border: 1.8px solid rgba(255, 255, 255, 0.42);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.38),
    inset 0 0 30px rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  animation: pulseItem 2.2s ease-out infinite;
}

.pulse-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 160px;
  height: 160px;
  border: 3.5px solid;
  border-radius: 50%;
  opacity: 0;
  animation: pulseRing 2.2s ease-out infinite;
}

.pulse-ring.delay {
  animation-delay: 1.15s;
}

@keyframes pulseItem {
  0%,
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes pulseRing {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  40% {
    opacity: 0.9;
  }
  100% {
    transform: scale(1.45);
    opacity: 0;
  }
}
</style>
